// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { isUndefined } from "@sequentech/ui-core";
export var stringifyFields = function (record, filterFields) {
    var o = {};
    if (filterFields) {
        for (var _i = 0, filterFields_1 = filterFields; _i < filterFields_1.length; _i++) {
            var key = filterFields_1[_i];
            if (!isUndefined(record[key])) {
                o[key] = record[key];
            }
        }
    }
    return JSON.stringify(o);
};
export var generateRowClickHandler = function (fields, show) {
    return function (id, resource, record) {
        return "/".concat(resource, "/").concat(id).concat(show ? "/show" : "").concat(fields ? "?filter=".concat(stringifyFields(record, fields)) : "");
    };
};
